import React, {useState} from "react";

import * as AssetsService from "../../api/AssetsService"
import cabinetStyle from "./MentorCabinet.module.css";
import PageTips from "../PageTips";
import Style from "../Style.module.css";
import {useEffectOnce} from "../../hooks/useEffectOnce";
import MyCardsPrivateNote from "./MyCardsPrivateNote";
import Banner from "./Banner";
import {useTranslation} from "react-i18next";


export default function MyCardsPrivateNotes(props) {
    const [notes, setNotes] = useState()
    const [fetched, setFetched] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'privateNotes' });


    function fetchNotes() {
        AssetsService.getPrivateNotes(
            (notes) => {
                setNotes(notes)
                setFetched(true)
            }, () => {
                window.alert(t('error'))
            })
    }

    useEffectOnce(() => {
        fetchNotes()
    }, [])

    return <>
        {fetched && <>
            {/*<Banner></Banner>*/}
            <div className={cabinetStyle.mainPageContainer}>
                <PageTips headerText={t('header')}>
                    <div className={Style.h5Heading}>{t('headerText1')}</div>
                    <ul>
                    <li className={Style.bodyBaseText}>{t('headerText2')}</li>
                    <li className={Style.bodyBaseText}>{t('headerText3')}</li>
                    <li className={Style.bodyBaseText}>{t('headerText4')}</li>
                </ul>
                </PageTips>
                <div>{
                    Object.entries(notes).map(([field_num, text]) => {
                        return <MyCardsPrivateNote cellNumber={field_num} text={text} fetchNotes={fetchNotes}/>
                    })} </div>
            </div>

        </>
        }
    </>
}